export default __webpack_public_path__ + "static/media/volvo.f3080a86.svg";